import script from "./TagsList.vue?vue&type=script&setup=true&lang=js"
export * from "./TagsList.vue?vue&type=script&setup=true&lang=js"

import "./TagsList.vue?vue&type=style&index=0&id=78e3f0b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78e3f0b2"]])

export default __exports__